<template>
  <v-container fluid align-start ma-0 pa-2 class="epms1020_detail-main container-height">
    <v-row no-gutters fill-height>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle" 
          :useBtnList="useBtnList"
          :unUseBtnList="unUseBtnList"
          :btnKey="useBtnListKey"
          @btnRetrieve="btnRetrieve"
        >
          <template v-slot:body>
            <v-row no-gutters>
              <v-col cols="12" class="pa-1">
                <v-icon small color="blue">mdi-circle</v-icon>
                <span class="pa-1 subTitle">Basic Information </span>
              </v-col>
            </v-row>

            <v-row dense class="form-layout">
              <v-col cols="12" class="pa-0">
                <v-row no-gutters>
                  <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                    <span>Quotation No</span>
                  </v-col>
                  <v-col cols="3">
                    <v-row no-gutters class="row__select-no">
                      <v-col cols="6">
                        <v-select
                          v-model="selectedQuot"
                          :items="quotList"
                          item-value="quotNo"
                          item-text="quotNo"
                          label="Select No"
                          return-object
                          single-line
                          outlined
                          dense
                          @change="quotNoChange"
                        ></v-select>
                      </v-col>
                      <v-col cols="6" class="pl-2 pt-1 quotNo">
                        {{ quotStepGbn }} 
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                    <span>Title</span>
                  </v-col>
                  <v-col cols="7">
                    <v-text-field 
                      v-model="headerData.quotTitle" 
                      dense 
                      outlined 
                      hide-details="auto"
                      readonly
                    />
                  </v-col>
                </v-row>

                <v-row no-gutters>
                  <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                    <span>Ship No, POR No</span>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field 
                      v-model="headerData.shipPorNo" 
                      dense 
                      outlined 
                      hide-details="auto"
                      readonly
                    />
                  </v-col>
                  <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                    <span>Start Date</span>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field 
                      v-model="headerData.startDte" 
                      dense 
                      outlined 
                      hide-details="auto"
                      readonly
                    />
                  </v-col>
                  <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                    <span>Finish Time</span>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field 
                      v-model="headerData.finishDte" 
                      dense 
                      outlined 
                      hide-details="auto"
                      readonly
                    />
                  </v-col>
                </v-row>

                <v-row no-gutters>
                  <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                    <span>Delivery Condition</span>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field 
                      v-model="headerData.transCondDesc" 
                      dense 
                      outlined 
                      hide-details="auto"
                      readonly
                    />
                  </v-col>
                  <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                    <span>Payment Condition</span>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field 
                      v-model="headerData.payCondDesc" 
                      dense 
                      outlined 
                      hide-details="auto"
                      readonly
                    />
                  </v-col>
                  <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                    <span>Purchase Charger</span>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field 
                      v-model="headerData.buyerName" 
                      dense 
                      outlined 
                      hide-details="auto"
                      readonly
                    />
                  </v-col>
                </v-row>
                
                <v-row no-gutters>
                  <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                    <span>Recieve Date</span>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field 
                      v-model="headerData.receiveDte" 
                      dense 
                      outlined 
                      hide-details="auto"
                      readonly
                    />
                  </v-col>
                  <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                    <span>Submit Date</span>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field 
                      v-model="headerData.submitDte" 
                      dense 
                      outlined 
                      hide-details="auto"
                      readonly
                    />
                  </v-col>
                  <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                    <span>Quotation Amount</span>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field 
                      v-model="headerData.quotationAmount"
                      dense 
                      outlined 
                      hide-details="auto"
                      readonly
                    />
                  </v-col>
                </v-row>

                <v-row no-gutters>
                  <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                    <span>Remark</span>
                  </v-col>
                  <v-col cols="7">
                    <v-text-field 
                      v-model="headerData.remark" 
                      dense 
                      outlined 
                      hide-details="auto"
                      readonly
                    />
                  </v-col>
                  <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                    <span>Money Unit</span>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      v-model="headerData.moneUnit"
                      dense 
                      outlined 
                      hide-details="auto"
                      readonly
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col cols="12" class="pt-1">
                <DxDataGrid id="epms1020Detail" 
                  :ref="epms1020DetailRef"
                  class="hipGridHeight5"
                  :data-source="dataList" 
                  :remote-operations="false" 
                  :hover-state-enabled="true"
                  :allow-column-resizing="true" 
                  :allow-column-reordering="true"
                  :row-alternation-enabled="true" 
                  :show-borders="true" 
                  :width="grid.width"
                  :show-row-lines="true" 
                  key-expr="id" 
                  :focused-row-enabled="false"
                  :column-hiding-enabled="false" 
                  :selection="{ mode: 'none' }"
                  :sorting="{ mode: 'none' }"
                  data-row-template="dataRowTemplate"
                  @cellPrepared="cellPrepared"
                >
                  <DxEditing :use-icons="true" />
                  <DxPaging :enabled="true" :page-size="5" />
                  <DxPager :allowed-page-sizes="[5, 'all']" />
                  <DxColumn caption="No" />
                  <DxColumn caption="Ship No">
                    <DxColumn caption="POR No" />
                  </DxColumn>
                  <DxColumn caption="Block">
                    <DxColumn caption="Part No" />
                  </DxColumn>
                  <DxColumn caption="P.Qty">
                    <DxColumn caption="Material Specification" />
                  </DxColumn>
                  <DxColumn caption="Unit Wgt">
                    <DxColumn caption="Material Specification1" />
                  </DxColumn>
                  <DxColumn caption="Total Wgt">
                    <DxColumn caption="Material Specification2" />
                  </DxColumn>
                  <DxColumn caption="Production Fee">
                    <DxColumn :caption="caption" header-cell-template="btnAllTmpl" />
                    <DxColumn caption="Prod." header-cell-template="btnAllTmpl" />
                    <DxColumn caption="Gal." header-cell-template="btnAllTmpl"/>
                    <DxColumn caption="Paint" header-cell-template="btnAllTmpl" />
                    <DxColumn caption="SP" header-cell-template="btnAllTmpl" />
                    <DxColumn caption="Treatment" header-cell-template="btnAllTmpl" />
                    <DxColumn caption="Sub. Total" />
                    <DxColumn caption="Others" />
                    <DxColumn caption="ACC" />
                    <DxColumn caption="Total" />
                  </DxColumn>
                  <template #btnAllTmpl="{ data: colInfo }">
                    <fragment>
                      <div>
                        {{ colInfo.column.caption }}
                      </div>
                      <div>
                        <i-button :text="'All'" :isCustom="true" />
                      </div>
                    </fragment>
                  </template>
                  <template #dataRowTemplate="{ data: rowInfo }">
                    <fragment>
                      <tr class="tr-row-template first-row" role="row">
                        <td rowspan="2" class="text-center">{{ rowInfo.data.id }}</td>
                        <td class="text-center">{{ rowInfo.data.shipNo }}</td>
                        <td class="text-center">{{ rowInfo.data.block }}</td>
                        <td class="text-center">{{ rowInfo.data.partQty }}</td>
                        <td class="pa-0 text-right">
                          <v-text-field hide-details="auto" solo class="grd-input" maxLength="12" @blur="rowInfo.data.partUnitWgt = getNumComma(rowInfo.data.partUnitWgt)"
                            v-model="rowInfo.data.partUnitWgt" />
                        </td>
                        <td class="text-center">{{ rowInfo.data.totWgt }}</td>
                        <td rowspan="2" class="pa-0 text-right">
                          <template v-if="editGbn === '0'">
                            <v-text-field hide-details="auto" solo class="grd-input" maxLength="12" @blur="rowInfo.data.sepAmt = getNumComma(rowInfo.data.sepAmt)"
                              v-model="rowInfo.data.sepAmt" />
                          </template>
                          <template v-else>
                            <div style="padding: 0 7px;">
                              <template v-if="editGbn === '1'">
                                {{ getNumComma(rowInfo.data.sepAmt) }}
                              </template>
                              <template v-else>
                                ************
                              </template>
                            </div>
                          </template>
                        </td>
                        <td rowspan="2" class="pa-0 text-right">
                          <template v-if="editGbn === '0'">
                            <v-text-field hide-details="auto" solo class="grd-input" maxLength="12" @blur="rowInfo.data.proAmt = getNumComma(rowInfo.data.proAmt)"
                              v-model="rowInfo.data.proAmt" />
                          </template>
                          <template v-else>
                            <div style="padding: 0 7px;">
                              <template v-if="editGbn === '1'">
                                {{ getNumComma(rowInfo.data.proAmt) }}
                              </template>
                              <template v-else>
                                ************
                              </template>
                            </div>
                          </template>
                        </td>
                        <td class="pa-0 text-right">
                          <template v-if="editGbn === '0'">
                            <v-text-field hide-details="auto" solo class="grd-input" maxLength="12" @blur="rowInfo.data.galQty = getNumComma(rowInfo.data.galQty)"
                              v-model="rowInfo.data.galQty" />
                          </template>
                          <template v-else>
                            <div style="padding: 0 7px;">
                              <template v-if="editGbn === '1'">
                                {{ getNumComma(rowInfo.data.galQty) }}
                              </template>
                              <template v-else>
                                ************
                              </template>
                            </div>
                          </template>
                        </td>
                        <td rowspan="2" class="pa-0 text-right">
                          <template v-if="editGbn === '0'">
                            <v-text-field hide-details="auto" solo class="grd-input" maxLength="12" @blur="rowInfo.data.pntAmt = getNumComma(rowInfo.data.pntAmt)"
                              v-model="rowInfo.data.pntAmt" />
                          </template>
                          <template v-else>
                            <div style="padding: 0 7px;">
                              <template v-if="editGbn === '1'">
                                {{ getNumComma(rowInfo.data.pntAmt) }}
                              </template>
                              <template v-else>
                                ************
                              </template>
                            </div>
                          </template>
                        </td>
                        <td rowspan="2" class="pa-0 text-right">
                          <template v-if="editGbn === '0'">
                            <v-text-field hide-details="auto" solo class="grd-input" maxLength="12" @blur="rowInfo.data.spAmt = getNumComma(rowInfo.data.spAmt)"
                              v-model="rowInfo.data.spAmt" />
                          </template>
                          <template v-else>
                            <div style="padding: 0 7px;">
                              <template v-if="editGbn === '1'">
                                {{ getNumComma(rowInfo.data.spAmt) }}
                              </template>
                              <template v-else>
                                ************
                              </template>
                            </div>
                          </template>
                        </td>
                        <td rowspan="2" class="pa-0 text-right">
                          <template v-if="editGbn === '0'">
                            <v-text-field hide-details="auto" solo class="grd-input" maxLength="12" @blur="rowInfo.data.trmAmt = getNumComma(rowInfo.data.trmAmt)"
                              v-model="rowInfo.data.trmAmt" />
                          </template>
                          <template v-else>
                            <div style="padding: 0 7px;">
                              <template v-if="editGbn === '1'">
                                {{ getNumComma(rowInfo.data.trmAmt) }}
                              </template>
                              <template v-else>
                                ************
                              </template>
                            </div>
                          </template>
                        </td>
                        <td rowspan="2" class="pa-0 text-right">
                          <template v-if="editGbn === '0'">
                            <v-text-field hide-details="auto" solo class="grd-input" maxLength="12" @blur="rowInfo.data.subAmt = getNumComma(rowInfo.data.subAmt)"
                              v-model="rowInfo.data.subAmt" />
                          </template>
                          <template v-else>
                            <div style="padding: 0 7px;">
                              <template v-if="editGbn === '1'">
                                {{ getNumComma(rowInfo.data.subAmt) }}
                              </template>
                              <template v-else>
                                ************
                              </template>
                            </div>
                          </template>
                        </td>
                        <td rowspan="2" class="pa-0 text-right">
                          <template v-if="editGbn === '0'">
                            <v-text-field hide-details="auto" solo class="grd-input" maxLength="12" @blur="rowInfo.data.othAmt = getNumComma(rowInfo.data.othAmt)"
                              v-model="rowInfo.data.othAmt" />
                          </template>
                          <template v-else>
                            <div style="padding: 0 7px;">
                              <template v-if="editGbn === '1'">
                                {{ getNumComma(rowInfo.data.othAmt) }}
                              </template>
                              <template v-else>
                                ************
                              </template>
                            </div>
                          </template>
                        </td>
                        <td class="text-right">{{ rowInfo.data.accAmt }}</td>
                        <td rowspan="2" class="pa-0 text-right">
                          <template v-if="editGbn === '0'">
                            <v-text-field hide-details="auto" solo class="grd-input" maxLength="12" @blur="rowInfo.data.totAmt = getNumComma(rowInfo.data.totAmt)"
                              v-model="rowInfo.data.totAmt" />
                          </template>
                          <template v-else>
                            <div style="padding: 0 7px;">
                              <template v-if="editGbn === '1'">
                                {{ getNumComma(rowInfo.data.totAmt) }}
                              </template>
                              <template v-else>
                                ************
                              </template>
                            </div>
                          </template>
                        </td>
                      </tr>
                      <tr class="tr-row-template second-row" role="row">
                        <td class="text-center">{{ rowInfo.data.porNo }}</td>
                        <td class="text-center">{{ rowInfo.data.partNo }}</td>
                        <td colspan="3">{{ rowInfo.data.partSpec }}</td>
                        <td class="pa-0 text-right">
                          <template v-if="editGbn === '0'">
                            <v-text-field hide-details="auto" solo class="grd-input" maxLength="12" @blur="rowInfo.data.galAmt = getNumComma(rowInfo.data.galAmt)"
                              v-model="rowInfo.data.galAmt" />
                          </template>
                          <template v-else>
                            <div style="padding: 0 7px;">
                              <template v-if="editGbn === '1'">
                                {{ getNumComma(rowInfo.data.galAmt) }}
                              </template>
                              <template v-else>
                                ************
                              </template>
                            </div>
                          </template>
                        </td>
                        <td class="text-center">
                          <i-button :text="'ACC'" :isCustom="true" />
                        </td>
                      </tr>
                    </fragment>
                  </template>
                </DxDataGrid>
              </v-col>
            </v-row>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import baseview from '@/components/base/baseview.vue'
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'
import notify from 'devextreme/ui/notify'
import { getQuotNoList, getRequestHead, getSubmitDetail1 } from '@/api/view/hip/common/common'
import { getNumComma } from '@/utils/common.js'
import iButton from '@/components/common/iButton'

export default {
  name: 'epms1020_detail',
  mixins: [baseview, BaseDataGrid],
  components: {
    iButton
  },
  data() {
    return {
      menuTitle: this.$route.meta.title,
      epms1020DetailRef: 'epms1020DetailRef',
      quotList: [],
      dataList: [],
      selectedQuot: null,
      useBtnListKey: 0,
      useBtnList: ['btnRetrieve', 'btnBomListToExcel', 'btnSave', 'btnSubmitToHVS'],
      useBtnListTemp: ['btnRetrieve', 'btnBomListToExcel', 'btnSave', 'btnSubmitToHVS'],
      unUseBtnList: [],
      headerData: {},
      editGbn: '0', // '0', '1', '2'
      quotStepGbn: '',
      caption: ''
    }
  },
  computed: {
    gridInstance() {
      return this.GetDataGrid(this.epms1020DetailRef)
    }
  },
  mounted() {
    this.gridInstance.option('defaultPaging', false)
    this.setCaption()
    this.getQuotNoList()
  },
  methods: {
    getNumComma(e) {
      const result = getNumComma(e, 2)
      return result
    },
    initData() {
      this.headerData = {}
      this.quotStepGbn = ''
      this.dataList = []
      this.unUseBtnList = []
      this.useBtnList = [],
      this.editGbn = '0'
    },
    setCaption() {
      if(this.$store.state.user.makerCd === '10252') {
        this.caption = 'Matl.'
      } else if(this.$store.state.user.makerCd === '13153') {
        this.caption = 'Trans.'
      } else {
        this.caption = 'Sper.'
      }
    },
    async getQuotNoList() {
      const param = {
        makerCd: this.$store.state.user.makerCd,
        quotStep: 'A',
        quotDiv: 'N',
        userId: this.$store.state.user.userId,
      }

      await getQuotNoList(param).then(res => {
        // console.log('res', res)
        
        const setVal = res.list.find(element => element.quotNo === this.$route.params.quotNo)

        this.quotList = res.list
        this.selectedQuot = setVal
        this.quotNoChange(setVal)
      })
    },
    quotNoChange(e) {
      if(e) {
        switch(e.quotStep) {
          case 'A2': this.quotStepGbn = '1st re-Quot'
            break
          case 'A3': this.quotStepGbn = '2nd re-Quot'
            break
          case 'A4': this.quotStepGbn = '3rd re-Quot'
            break
          default: this.quotStepGbn = ''
            break
        }

        this.getQuotData()
      }
    },
    setBtnList() {
      let btnTemp = this.$_.cloneDeep(this.useBtnListTemp)

      // console.log('this.headerData.submitYn', this.headerData.submitYn)
      // console.log('this.headerData.pipeYn', this.headerData.pipeYn)

      if(this.headerData.submitYn === 'Y') {
        this.unUseBtnList.push('btnSave')
        this.unUseBtnList.push('btnSubmitToHVS')
      }

      // console.log('btnTemp', btnTemp)

      this.useBtnList = btnTemp
      this.useBtnListKey++
    },
    async getQuotData() {
       try {
        this.initData()
        this.openLoading('searching')

        const param = {
          quotNo: this.selectedQuot.quotNo,
          quotStep: this.selectedQuot.quotStep,
          makerCd: this.$store.state.user.makerCd,
          quotDiv: ''
        }

        await getRequestHead(param).then(res => {
          // console.log('headRes', res)

          if(res.list.length > 0) {
            this.headerData = res.list[0]

            this.headerData.quotationAmount = 0
            this.headerData.payPct = 0

            if(!this.headerData.submitYn || this.headerData.submitYn === 'N') {
              this.editGbn = '0'
            } else if(!this.headerData.printYn || this.headerData.printYn === 'N') {
              this.editGbn = '1'
            } else {
              this.editGbn = '2'
            }
          }
        })

        await getSubmitDetail1(param).then(res => {
          // console.log('submitDetail1Res', res)

          let detail = res.list
          for(let i = 0; i < detail.length; i++) {
            detail[i].partQty = this.getNumComma(detail[i].partQty)
            detail[i].partUnitWgt = this.getNumComma(detail[i].partUnitWgt)
            detail[i].totWgt = this.getNumComma(detail[i].totWgt)
            detail[i].sepAmt = this.getNumComma(detail[i].sepAmt)
            detail[i].proAmt = this.getNumComma(detail[i].proAmt)
            detail[i].galQty = this.getNumComma(detail[i].galQty)
            detail[i].galAmt = this.getNumComma(detail[i].galAmt)
            detail[i].pntAmt = this.getNumComma(detail[i].pntAmt)
            detail[i].spAmt = this.getNumComma(detail[i].spAmt)
            detail[i].trmAmt = this.getNumComma(detail[i].trmAmt)
            detail[i].subAmt = this.getNumComma(detail[i].subAmt)
            detail[i].othAmt = this.getNumComma(detail[i].othAmt)
            detail[i].accAmt = this.getNumComma(detail[i].accAmt)
            detail[i].totAmt = this.getNumComma(detail[i].totAmt)
          }
          this.dataList = detail
        })

        this.setBtnList()
      } finally {
        this.endLoading()
      }
    },
    cellPrepared(e) {
      if(e.rowType === 'header') {
        if(e.column.caption.indexOf('Material Specification') > -1) {
          if(e.column.caption === 'Material Specification') {
            e.cellElement.setAttribute('colspan', 3)
          } else {
            e.cellElement.style.display = 'none'
          }
        }
      }
    },
    btnRetrieve() {
      // console.log('this.dataList', this.dataList)
      
      if(!this.selectedQuot || !this.selectedQuot.quotNo) {
        this.vToastify(this.$t('There is no quotation no.'), 'warn')
        return
      }

      this.quotNoChange(this.selectedQuot)
    }
  }
}
</script>

<style lang="scss" scoped>
$redBtn: #FF0000;

.form-layout::v-deep .col {
  border-width: 1px 0 0 1px;
  border-style: solid;
  border-color: gray;
  
  * {
    border: 0px none !important;
  }

  .row:not(.row__select-no) {
    border-width: 0 0 1px 0 !important;
    border-style: solid !important;
    border-color: gray !important;
  }

  .col:not(.quotNo) {
    border-width: 0 1px 0 0 !important;
    border-style: solid !important;
    border-color: gray !important;
  }
}
.formHeader {
   background-color: rgb(223, 227, 213);
   font-weight: bold;
   // border: 1px solid gray;
   color: black;
   font-size: 9pt;
 }

 .formHeader2 {
   background-color: rgb(214, 243, 247);
 }

.subTitle {
  font-weight: bold;
  color: black;
}
.subTitle2 {
  font-weight: bold;
  color: red;
}
.quotNo {
  font-weight: bold;
  border: 1px solid gray;
  border-bottom: 0px;
  color: #0000FF;
  font-size: 9pt;
}

::v-deep {
  [role=btnSave]:not([disabled=disabled]), [role=btnSubmitToHVS]:not([disabled=disabled]) {
    .v-btn__content {
      div, i {
        color: #{$redBtn} !important;
      }
    }
  }
}

::v-deep.grd-input.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot,
.v-text-field.v-text-field--enclosed .v-text-field__details {
  background: transparent;

  input {
    text-align: right;
  }
}

.tr-row-template.first-row {
  td {    
    border-bottom:  1px solid #ddd !important;
    border-right:  1px solid #ddd !important;
    border-left:  1px solid #ddd !important;
  }

  td:first-of-type {
    border-left: none !important;
  }

  td:last-of-type {
    border-right: none !important;
  }
}

.tr-row-template.second-row {
  td {    
    border-bottom:  1px solid #ddd !important;
    border-right:  1px solid #ddd !important;
    border-left:  1px solid #ddd !important;
  }
}

</style>